export default __webpack_public_path__ + "static/Answer, summarise, prioritise-5443a5721815ff7ed2c38d6aea63c95d.png";